const { Type } = require('@sinclair/typebox');
const { merge } = require('lodash');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');

/** Builds the TypeBox schema fragment for the MultiPickerDropDown form element. */
function asDataDictionary(hNode, context) {
    const { id, foreignNamespace, foreignRelation, propertyOverride, required } = hNode;

    // This block tells us the foreign namespaces/relations should exist
    // and the filters will tell us about properties we'd expect to be on there
    let [_subDataDictionary = {}, _partialTypeDefinition = {}] = hNode.children?.reduce(
        ([sdd, ptd], child) => {
            const [_subDataDictionary = {}, _partialTypeDefinition = {}] = context.extractFromChild(child, context);
            return [
                merge(sdd, _subDataDictionary),
                moduleRegistration.mergePartialTypeDefinitions(ptd, _partialTypeDefinition, context)
            ];
        },
        [{}, {}]
    ) ?? [{}, {}];

    // Merge the child subdictionaries with any filter-contributed data
    const subDataDictionary = _subDataDictionary;

    // reuse consistent flags
    const { isOptional, schemaOptions } = moduleRegistration.resolveFieldFlags(required, context);
    const maybeOptional = schema => (isOptional ? Type.Optional(schema) : schema);

    // MultiPicker dropdowns share the same lookup-vs-storage split as single dropdowns:
    // query the foreign relation, but write the selected records to the override when supplied.
    const propertyName = propertyOverride || `${foreignNamespace}:${foreignRelation}`;

    // Build the array schema with object items containing _id and title
    const itemSchema = Type.Object(
        {
            _id: Type.String({
                title: 'Unique ID',
                'x-propertyName': '_id',
                'x-dataType': 'string'
            }),
            title: Type.String({
                title: 'title',
                'x-propertyName': 'title',
                'x-dataType': 'string'
            })
        },
        {
            title: 'Item',
            'x-dataType': 'object',
            additionalProperties: true
        }
    );

    const arraySchema = maybeOptional(
        Type.Array(itemSchema, {
            title: `${foreignNamespace}:${foreignRelation}`,
            'x-id': id,
            'x-dataType': 'array',
            'x-propertyName': propertyName,
            ...schemaOptions,
            'x-foreignNamespace': foreignNamespace,
            'x-foreignRelation': foreignRelation
        })
    );

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
        [propertyName]: arraySchema
    };

    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { asDataDictionary };
